import { useCallback } from "react";
import { usePostFirmsFirmIdJobsJobIdLogFileError } from '@taxassist/api-client';

import { useCurrentFirmId } from '../contexts/FirmContext';
import { useAuth } from "../contexts/AuthContext";


type FileErrorPayload = {
  fileName: string,
  errorType: "PasswordProtection" | "MagicByteMismatch" | "CorruptedFile",
  errorMessage: string,
  details?: Record<string, unknown>,
}

export function useLogFileError() {

  const firmId = useCurrentFirmId();
  const { user } = useAuth();
  const postFirmsFirmIdJobsJobIdLogFileError = usePostFirmsFirmIdJobsJobIdLogFileError();

  const logFileError = useCallback(
    async (
      jobId: string,
      payload: FileErrorPayload,
    ) => {

      if (!firmId) {
        console.error("logFileError called without a firmId.");
        return;
      }

      return postFirmsFirmIdJobsJobIdLogFileError.mutate({
        jobId,
        firmId: firmId,
        data: {
          ...payload,
          userId: user?.userId,
        },
      });
    },
    [firmId, user, postFirmsFirmIdJobsJobIdLogFileError]
  );

  return { logFileError };
}
